import { Box, Button, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Switch, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { IState } from "../../redux/reducers/rootReducers";
import { returnFormValues } from "../helpers/helperFunctions";
import { ContactByTokenAction, PreferenceUpdateToastSsp, UpdateContactsSsp } from "../../redux/actions/ContactManagement/Contact";
interface ISspPreference {
    loginUser?: { [key: string]: any };
    dispatch?: any;
}
const SspPreference = ({ loginUser, dispatch }: ISspPreference) => {
    const defaultPreference = JSON.parse(loginUser?.contactPreferences?.TicketDashboardFilterValues || "{}");

    const [themeMode, setThemeMode] = useState("light-mode");

    const [suggestArticle, setsuggestArticle] = useState(defaultPreference?.suggestArticles || false);
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setsuggestArticle(event.target.checked);
    };

    useEffect(() => {   
        setsuggestArticle(defaultPreference?.suggestArticles || false)
        setThemeMode(defaultPreference?.theme || "light-mode");
    }, [loginUser]);


    const onSubmit = (e: any) => {
        e.preventDefault();
        const data = returnFormValues(e.currentTarget);
//         console.log(data, loginUser);
        const toUpdate = {"theme": data.theme, "suggestArticles": suggestArticle};

        const userObj = JSON.parse(JSON.stringify(loginUser));
        userObj.contactPreferences = { ...userObj.contactPreferences, TicketDashboardFilterValues:  JSON.stringify({...defaultPreference,...toUpdate})};
        
//         console.log("Updated User Object: ", userObj);
        dispatch(UpdateContactsSsp(userObj, submitHandlerCB));
        dispatch(PreferenceUpdateToastSsp());
        
    };
    const submitHandlerCB = () => {
        dispatch(ContactByTokenAction());
    };
    return (
        <Box sx={{ p: 2 }}>
            <Typography component={"h2"} sx={{ fontSize: 24 }} gutterBottom>Preferences</Typography>
            <hr />
            <Box component={"form"} onSubmit={onSubmit}>
                <Box sx={{ pb: 2 }}>
                    <FormControl>
                        <FormLabel id="theme-field">Theme</FormLabel>
                        <RadioGroup
                            row
                            aria-labelledby="theme-field"
                            name="theme"
                            onChange={(e:any) => setThemeMode(e.target.value)}
                            // defaultValue={defaultPreference?.theme || "light-mode"}
                            value ={themeMode}
                        >
                            <FormControlLabel value="light-mode" control={<Radio size="small" />} label="Light Mode" />
                            <FormControlLabel value="dark-mode" control={<Radio size="small" />} label="Dark Mode" />
                        </RadioGroup>
                    </FormControl>
                </Box>
                <Box>
                    <FormControl>
                        <FormLabel id="view-field">Suggest Articles</FormLabel>
                        <Switch
                            checked={suggestArticle}
                            onChange={handleChange}
                            inputProps={{ 'aria-label': 'controlled' }}
                        />
                    </FormControl>
                </Box>
                <Box className="pt-2">
                <Button type="submit" variant="contained">
                  Update Preferences
                </Button>
              </Box>
            </Box>
        </Box>
    );
}


const mapStateToProps = (state: IState) => {
    return ({
        loginUser: state?.ContactsReducer?.loggedContact
    })
};

export default connect(mapStateToProps)(SspPreference);
// export default SspPreference;